// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"styles_iconsWrapper__367Ae","arrowUp":"styles_arrowUp__3mPke","arrowDown":"styles_arrowDown__3HCe7","iconsActive":"styles_iconsActive__1fJEY"};